import React from 'react';
import { Box, VStack, HStack, Text, Badge } from '@chakra-ui/react';
import { ScaleFade } from '@chakra-ui/transition';
import { Player } from '../types';


interface ScoreboardProps {
  players: Player[];
  currentPlayerIndex: number;
}

const colors = ['teal.400', 'blue.400', 'purple.400', 'orange.400', 'pink.400', 'green.400'];

const Scoreboard: React.FC<ScoreboardProps> = ({ players, currentPlayerIndex }) => {
  return (
    <Box maxW="md" mx="auto" mt={8} mb={8} p={6} borderRadius="2xl" boxShadow="xl" bg="whiteAlpha.900">
      <VStack  align="stretch">
        {players.map((player, idx) => (
          <ScaleFade key={player.name} in={true} initialScale={0.95}>
            <HStack
              p={3}
              borderRadius="xl"
              bg={idx === currentPlayerIndex ? colors[idx % colors.length] : 'gray.100'}
              boxShadow={idx === currentPlayerIndex ? 'lg' : undefined}
              transition="all 0.2s"
              justify="space-between"
            >
              <HStack>
                <Text fontWeight="bold" color={idx === currentPlayerIndex ? 'white' : 'gray.700'}>
                  {player.name}
                </Text>
                {idx === currentPlayerIndex && (
                  <Badge colorScheme="yellow" fontSize="0.8em">Your Turn</Badge>
                )}
              </HStack>
              <Text fontSize="xl" fontWeight="extrabold" color={idx === currentPlayerIndex ? 'white' : 'teal.600'}>
                {player.total}
              </Text>
            </HStack>
          </ScaleFade>
        ))}
      </VStack>
    </Box>
  );
};

export default Scoreboard; 